import { Mixin, Mixins } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Mixin
class SearchMixin extends Vue {
    protected searchString = '';
    protected remainingTime = 1500;
    protected searchTimeout!: any;
    protected searchNifString = '';
    protected searchPhoneString = '';

    public searchCallback() {
        // tslint:disable-next-line:no-console
        console.log('implement me!');
    }

    // Espera a que el usuario deje de escribir; al vaciar el campo busca al momento.
    protected debounceSearch(value: string, callback = () => this.searchCallback()) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(callback, value === '' ? 0 : this.remainingTime);
    }

    @Watch('searchString')
    public watchSearchString(newVal: string) {
        this.debounceSearch(newVal);
    }

    @Watch('searchNifString')
    public watchSearchNifString(newVal: string) {
        this.debounceSearch(newVal);
    }

    @Watch('searchPhoneString')
    public watchSearchPhoneString(newVal: string) {
        this.debounceSearch(newVal);
    }

}

export default SearchMixin;
